import _ from 'lodash/object';
var unorm = require('unorm');

const initialState = {
    path: [],
    menu: {
        disableOptions: [],
        filtersOnMenu: [],
        collapseOptions: true
    },
    filters: {
        collapseAll: false,
        hideFiltersOnMenu: false,
        dataTotalLimit: 150000,
        ddEnabled: true
    },
    ui: ''
}

const menuReducer = (state = {}, action) => {
    switch (action.type) {
        case 'COLLAPSE':
            return { ...state, collapseOptions: action.payload }
        default: return state;
    }
}

const filterReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_COLLAPSE_ALL':
            return { ...state, collapseAll: action.payload };
        case 'SET_DD_ENABLED':
            return { ...state, ddEnabled: action.payload };
        default: state;
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CONFIG':
            const nState = { ...state, path: [] };
            return _.merge({ ...nState }, action.payload);
        case 'IS_LOADED':
            return { ...state, isLoading: action.payload }
        case 'COLLAPSE':
            return { ...state, menu: menuReducer(state.menu, action) };
        case 'SET_COLLAPSE_ALL':
        case 'SET_DD_ENABLED':
            return { ...state, filters: filterReducer(state.filters, action) }
        default: return state;
    }
}
